import PagesModalContainer from './PagesModalContainer'
import PagesModal from './PagesModal'
export { PagesModal }
export { PagesModalContainer }
export default PagesModalContainer



// WEBPACK FOOTER //
// ./src/components/PagesModal/index.js